/**
 * Optioutlet — botón "Comprar" de la ficha de producto.
 *
 * Sustituye a las carteras aceleradas de Shopify. Agrega la variante
 * seleccionada al carrito y de ahí manda al checkout, para que el cliente
 * tenga un solo camino directo de compra.
 *
 * El listener va delegado en el documento a propósito: la galería y el
 * bloque de compra se vuelven a renderizar al cambiar de variante, y un
 * listener sobre el botón se perdería en cada re-render.
 */
(() => {
  const SELECTOR = '[data-ol-buy-now]';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();

    // Evita que un doble clic mande dos veces el mismo producto.
    if (button.hasAttribute('aria-busy')) return;

    const form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    button.setAttribute('aria-busy', 'true');

    const root = window.Shopify?.routes?.root ?? '/';

    try {
      const response = await fetch(`${root}cart/add.js`.replace('//', '/'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error(`cart/add respondio ${response.status}`);

      window.location.assign(button.dataset.checkoutUrl || '/checkout');
    } catch (error) {
      // Si falla, devolvemos el boton a su estado normal en vez de dejar al
      // cliente frente a un boton muerto.
      button.removeAttribute('aria-busy');
      console.error('[optioutlet] no se pudo iniciar la compra:', error);
    }
  });
})();
